import React from 'react'
import { Header, HTMLText } from '@crossfit/ui'

import InnerContent from 'components/InnerContent'
import { useSettings } from 'components/Settings'

function IneligiblePage() {
  const { titleText, descriptionText } = useSettings(
    (s) => s.data.programming.ineligible,
  )

  return (
    <InnerContent>
      <Header as='h2' size='large' mb={2}>
        {titleText}
      </Header>
      <HTMLText>{descriptionText}</HTMLText>
    </InnerContent>
  )
}

export default IneligiblePage
